import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses an httpOnly cookie set by the backend — no tokens in localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const coverUrl = (id) => `${API}/ebooks/${id}/cover`;
export const coverFileUrl = (coverId) => `${API}/ebooks/cover-file/${coverId}`;
export const downloadUrl = (id, fmt, sessionId = "") =>
  `${API}/ebooks/${id}/download/${fmt}${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ""}`;

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
